export const state = {
    recaptchaLoaded: false,
    reCaptchaSiteKey: '6LcP-McqAAAAABG616o9tg0O7quZcfbEqr0iikaD'
}
